import { useEffect, useRef, useState } from 'react';
import { useTranslate } from 'ra-core';
import { SecurityInventoryCategory } from '@x-guard/xgac-types/xgac';
import { useOutsideAlerter } from '../../../../../utils/useOutsideAlerter';
import { FilterRow } from '../../../components/deviceFilters';
import { InventoryItemFilter } from '../util';

export const InventoryItemFilters = (props: {
  filters: InventoryItemFilter;
  onChange: (filters: InventoryItemFilter) => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  categories: SecurityInventoryCategory[];
}) => {

  const translate = useTranslate();
  const filterRef = useRef(null);
  const [openFilter, setOpenFilter] = useState<'categories' | 'status' | null>(null);
  const [innerFilters, setInnerFilters] = useState(props.filters);

  useOutsideAlerter(filterRef, () => props.onOpenChange(false));

  useEffect(() => {

    if (props.open) {

      setInnerFilters(props.filters);

    }

  }, [props.open, props.filters]);

  if (!props.open) {

    return null;

  }
  return (
    <div className="device-filter-div" ref={filterRef}>
      <div className="device-filter-div-inner">
        <ul onClick={() => {

          setOpenFilter(null);

        }}>
          <FilterRow
            label={'resources.security-inventory-items.text.filter_category'}
            buttonLabelAll={'resources.security-inventory-items.text.all_categories'}
            buttonLabelSome={'resources.security-inventory-items.text.categories_chosen'}
            open={openFilter === 'categories'}
            setOpenFilter={() => setOpenFilter(openFilter === 'categories' ? null : 'categories')}
            onChange={(selectedOptions: string[] | number[]) => setInnerFilters(
              { ...innerFilters, categories: selectedOptions as string[] },
            )}
            options={props.categories.map((category) => ({ label: category.name, value: category._id }))}
            selected={innerFilters.categories}
          />
          <FilterRow
            label="resources.security-inventory-items.text.filter_status"
            buttonLabelAll="resources.security-inventory-items.text.all_statuses"
            buttonLabelSome="resources.security-inventory-items.text.statuses_chosen"
            open={openFilter === 'status'}
            setOpenFilter={() => setOpenFilter(openFilter === 'status' ? null : 'status')}
            onChange={(selectedOptions: string[] | number[]) => setInnerFilters(
              { ...innerFilters, status: selectedOptions as InventoryItemFilter['status'] },
            )}
            options={[
              { label: translate('resources.security-inventory-items.text.status.valid'), value: 'valid' },
              { label: translate('resources.security-inventory-items.text.status.expiring'), value: 'expiring' },
              { label: translate('resources.security-inventory-items.text.status.expired'), value: 'expired' },
            ]}
            selected={innerFilters.status}
          />
        </ul>
        <div className="device-filter-buttons">
          <button onClick={() => {

            props.onChange({
              categories: [], status: [],
            });
            props.onOpenChange(false);

          }}>{translate('resources.buttons.text.remove_filters')}</button>
          <button onClick={() => {

            props.onChange(innerFilters);
            props.onOpenChange(false);

          }}>{translate('resources.buttons.text.save_filters')}</button>
        </div>
      </div>
    </div>
  );

};
